import React from 'react';
import { Carousel } from 'antd';

const introductionImages = require.context(
  '../../../../Assets/Linkages/SpaceDestinationSchools/Introduction',
  false,
  /\.jpg$/i,
);

const images = introductionImages.keys().sort().map((key) => {
  const image = introductionImages(key);
  return image.default || image;
});

const SpaceDestinationIntroduction = () => (
  <section className="space-destination-introduction" aria-labelledby="space-destination-introduction-title">
    <div className="space-destination-introduction-inner">
      <div className="space-destination-introduction-copy">
        <p className="section-eyebrow">BRINGING SPACE EDUCATION CLOSER</p>
        <h1 id="space-destination-introduction-title">Introduction</h1>
        <div className="world-space-week-title-line" aria-hidden="true" />
        <p>
          The Space Destination Schools initiative brings the excitement of space education to
          students in remote and underserved regions of Pakistan through short-term, immersive
          learning camps held over two to three days. Hosted at selected schools, the program also
          invites students from surrounding schools and colleges to participate in a shared learning
          experience. Through engaging lectures, interactive workshops, and hands-on activities,
          students explore the fascinating realms of Astronomy, Earth Science, Aviation, Rocketry,
          and Satellite Technology. They build solar system models, design gliders and student
          satellites, launch water rockets, and observe the skies using telescopes and simulations.
        </p>
      </div>

      <Carousel
        className="space-destination-introduction-carousel"
        autoplay
        autoplaySpeed={3800}
        pauseOnHover
        dots
        effect="fade"
      >
        {images.map((src, index) => (
          <figure key={src}>
            <img
              src={src}
              alt={`Space Destination Schools learning activity ${index + 1}`}
              loading="lazy"
            />
          </figure>
        ))}
      </Carousel>
    </div>
  </section>
);

export default SpaceDestinationIntroduction;
